import React, { Component } from "react";
import { connect } from "react-redux";
import Backend from "react-dnd-html5-backend";
import warning from "../../assets/icons/warning.png";
import DraggableComponent from "./../../components/DraggableComponent";
import { DndProvider } from "react-dnd";
import { updateTutorSettings, getSetting } from "../../apis/tutors";
import { TutorSettingAction } from "./../../redux/actions";
import { SettingHeader } from "./../TutorSetting/SpecificSettingComp";
import { Image, Dropdown, DropdownButton } from "react-bootstrap";
import { InfoModal } from "./../../components/modals/InfoModal";
import { Col, Row } from "react-bootstrap";
import BackIdPic from "../TutorApplicationForm/BackIdPic";
import FrontIdPic from "../TutorApplicationForm/FrontIdPic";
import CertificatePic from "../TutorApplicationForm/CertificatePic";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

class TutorSettingIdentification extends Component {
		
	constructor() {
		super();
		this.state = {
		typeOfDocument: 0,
		authorizeToRunBgCheck: false,
		frontOfCardUrl: "",
		backOfCardUrl: "",
		dBSCertUrl: "",
		countryRegion: "United Kingdom",
		country: ["Pakistan", "United Kingdom", "USA", "Canada", "Srilanka"],
		imageErrorMessage: "",
		certificateError: false,
		showAlert: false,
		show: false,
		show1: false,
		validationerror: false,
		};
	}

	componentDidMount = () => {
		let {
		typeOfDocument,
		authorizeToRunBgCheck,
		frontOfCardUrl,
		backOfCardUrl,
		dBSCertUrl,
		} = this.state;
		const { tutorSettingData } = this.props;
		let verificationDoc = tutorSettingData?.tutorDetails?.verificationDoc;
		typeOfDocument = verificationDoc?.typeOfDocument
		? verificationDoc?.typeOfDocument
		: "";
		authorizeToRunBgCheck = verificationDoc?.authorizeToRunBgCheck
		? verificationDoc?.authorizeToRunBgCheck
		: "";
		frontOfCardUrl = verificationDoc?.frontOfCardUrl
		? verificationDoc?.frontOfCardUrl
		: "";
		backOfCardUrl = verificationDoc?.backOfCardUrl
		? verificationDoc?.backOfCardUrl
		: "";
		dBSCertUrl = verificationDoc?.dBSCertUrl ? verificationDoc?.dBSCertUrl : "";
		this.setState({
		typeOfDocument,
		authorizeToRunBgCheck,
		frontOfCardUrl,
		backOfCardUrl,
		dBSCertUrl,
		});
	};

	componentDidUpdate = (prevProps) => {
		let {
		typeOfDocument,
		authorizeToRunBgCheck,
		frontOfCardUrl,
		backOfCardUrl,
		dBSCertUrl,
		} = this.state;
		const { tutorSettingData } = this.props;
		if (
		JSON.stringify(prevProps.tutorSettingData) !==
		JSON.stringify(tutorSettingData)
		) {
		let verificationDoc = tutorSettingData?.tutorDetails?.verificationDoc;
		typeOfDocument = verificationDoc?.typeOfDocument
			? verificationDoc?.typeOfDocument
			: "";
		authorizeToRunBgCheck = verificationDoc?.authorizeToRunBgCheck
			? verificationDoc?.authorizeToRunBgCheck
			: "";
		frontOfCardUrl = verificationDoc?.frontOfCardUrl
			? verificationDoc?.frontOfCardUrl
			: "";
		backOfCardUrl = verificationDoc?.backOfCardUrl
			? verificationDoc?.backOfCardUrl
			: "";
		dBSCertUrl = verificationDoc?.dBSCertUrl
			? verificationDoc?.dBSCertUrl
			: "";
		this.setState({
			typeOfDocument,
			authorizeToRunBgCheck,
			frontOfCardUrl,
			backOfCardUrl,
			dBSCertUrl,
		});
		}
	};

	updateIdenticationDetail = () => {
		let user = JSON.parse(localStorage.getItem("userDetail"));
		let user_id = user.user.userId;
		const {
		typeOfDocument,
		authorizeToRunBgCheck,
		frontOfCardUrl,
		backOfCardUrl,
		dBSCertUrl,
		} = this.state;
		let updateSettingParam = {
		updateSetting: {
			verificationDoc: {
			typeOfDocument,
			authorizeToRunBgCheck,
			frontOfCardUrl,
			backOfCardUrl,
			dBSCertUrl,
			},
		},
		};

		updateTutorSettings(updateSettingParam)
		.then((res) => {
			getSetting({ user_id })
			.then((res) => {
				InfoModal("Updates", "Successfully Update");
				this.setState({
				loader: false,
				});
			})
			.catch((err) => console.log(err));
		})
		.catch((err) => {
			console.log(err);
			this.setState({
			loader: false,
			});
		});
	};

	showAlert = () => {
		confirmAlert({
			title: "Type ",
			title: "Please select a PDF",
			buttons: [{
				label: "Ok",
				onClick: () => this.setState({ certificateError: false }) 
			},],
			closeOnEscape: true,
		});
	};

	show = () => {

		if( !this.state.show1 ) {

			this.setState({ show: true });

		}
		
	};

	show1 = () => {

		if( !this.state.show ) {

			this.setState({ show1: true });

		}

	};
	
	hide = () => {

		this.setState({ show: false });

	};

	hide1 = () => {

		this.setState({ show1: false });
		
	};

	onSave1 = () => {
		
		const { frontOfCardUrl, backOfCardUrl } = this.state;

		if( frontOfCardUrl && backOfCardUrl ) {
			this.setState({ show1: false })
		}
		else this.setState({ validationerror: true });

	};

	onSave = () => {

		const { CertificatePic } = this.state;

		if( CertificatePic ) {
			this.setState({ show: false })
		}
		else this.setState({ certifError: true });

	};

	render() {
		const { isModalIdentification, onHide } = this.props;
		const {
		authorizeToRunBgCheck,
		country,
		countryRegion,
		dBSCertUrl,
		frontOfCardUrl,
		backOfCardUrl,
		typeOfDocument,
		imageErrorMessage,
		certificateError,
		show,
		show1,
		certifError,
		validationerror,
		} = this.state;

		let warningError = ( <img src={warning} alt="warning" width="14px" height="14px" style={{ marginRight: "6px" }}/> );

		return (
			<div className="container">
				<Row className="flex-center-center">
					<Col lg={8} md={8} sm={12} xs={12} className="tutor-setting-Identification">
						<SettingHeader
						settingName={"Background and identity"}
						headerTitle={"Background and identity"}
						headerDesciption={"Update your ID or provide us with an enhanced DBS or PVG certiﬁcate "}
						goToAccount={() => this.props.history.push("/tutor-setting")}
						/>
						{
							!show1 ? (
								<div>
									<div className="flex-between-center">
										<label className="label">Official ID</label>
										<span className="btn-a" onClick={this.show1} style={{ color: show ? "#d8d7d7" : "" }}>
											Update
										</span>
									</div>
									<p className="Text-messages">You have verified your identity</p>
								</div>
							) : 
							(
								<div>

									<div className="flex-between-center">
										<label className="label">Add your official ID</label>
										<span className="btn-a" onClick={this.hide1}>Cancel</span>
									</div>
									<p className="Text-messages">
										This helps us check that you are really you. Identityverification is one of the 
										ways to keep Askademia secure.
									</p>

									<p className="label small">Issuing country/region</p>
									<div className="row">
										<div className="col-12 country">
										<DropdownButton
											id="dropdown-basic-button"
											title={
											<span>
												{countryRegion ? countryRegion : "Select Country"}
												<Image
												style={{ width: "15px" }}
												src={require("./../../assets/icons/down-arrow.png")}
												/>
											</span>
											}
										>
											{
											country && country.length ? (
												country.map((countryRegion, index) => {
												return (
													<Dropdown.Item
													key={index}
													className="dropdown-items"
													onClick={() => this.setState({ countryRegion: countryRegion })}
													key={index}
													>
													{countryRegion}
													</Dropdown.Item>
												);
												})
											) : (
												<Dropdown.Item className="dropdown-items">
												No Data
												</Dropdown.Item>
											)}
										</DropdownButton>
										</div>
									</div>
									
									<p className="label small">Type of document</p>
									<div className="row">
										<div className="col-lg-12 green-radio-custom">
										<div className="custom-control custom-radio custom-control-inline">
											<input
											type="radio"
											id="customRadioInline73"
											name="customRadioInline73"
											className="custom-control-input"
											defaultChecked={typeOfDocument === 6 ? true : false}
											/>
											<label
											className="custom-control-label"
											htmlFor="customRadioInline73"
											onClick={() => this.setState({ typeOfDocument: 6, imageErrorMessage: "" })}
											>
											Driver’s licence
											</label>
										</div>
										<div className="custom-control custom-radio custom-control-inline">
											<input
											type="radio"
											id="customRadioInline74"
											name="customRadioInline73"
											className="custom-control-input"
											defaultChecked={typeOfDocument === 4 ? true : false}
											/>
											<label
											className="custom-control-label"
											htmlFor="customRadioInline74"
											onClick={() => this.setState({ typeOfDocument: 4, imageErrorMessage: "" })}
											>
											Passport
											</label>
										</div>
										<div className="custom-control custom-radio custom-control-inline">
											<input
											type="radio"
											id="customRadioInline75"
											name="customRadioInline73"
											className="custom-control-input"
											defaultChecked={typeOfDocument === 1 ? true : false}
											/>
											<label
											className="custom-control-label"
											htmlFor="customRadioInline75"
											onClick={() => this.setState({ typeOfDocument: 1, imageErrorMessage: "" })}
											>
											Identity card
											</label>
										</div>
										</div>
									</div>
									
									<p className="label">Upload images of your ID</p>
									<p  className="Text-messages">
										Upload images of the front and back of your ID. Make sure your
										images are not cropped, covered or blurred and the front clearly
										shows your face.
									</p>
									
									<div className="error">
										{!typeOfDocument
										? imageErrorMessage
											? warningError
											: validationerror
											? warningError
											: ""
										: ""}
										{!typeOfDocument
										? imageErrorMessage
											? imageErrorMessage
											: validationerror
											? "Please select type of document before uploading"
											: ""
										: ""}
									</div>
									
									<div className="row">
										<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
										<DndProvider backend={Backend}>
											<DraggableComponent
											TargetChildComponent={FrontIdPic}
											validationerror={validationerror}
											errorMessagehandling={(error) => this.setState({ imageErrorMessage: error })}
											updateImageUrl={(e) => this.setState({ frontOfCardUrl: e })}
											imageUrl={frontOfCardUrl}
											typeNo={
												typeOfDocument
												? typeOfDocument === 1
													? "1"
													: typeOfDocument === 6
													? "6"
													: "4"
												: ""
											}
											/>
										</DndProvider>
										<div className="error">
											{!frontOfCardUrl
											? validationerror
												? warningError
												: ""
											: ""}
											{!frontOfCardUrl
											? validationerror
												? "Add a photo of the front of the identity document"
												: ""
											: ""}
										</div>
										</div>
										<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
										<DndProvider backend={Backend}>
											<DraggableComponent
											TargetChildComponent={BackIdPic}
											validationerror={validationerror}
											errorMessagehandling={(error) => this.setState({ imageErrorMessage: error })}
											updateImageUrl={(e) => this.setState({ backOfCardUrl: e })}
											imageUrl={backOfCardUrl}
											typeNo={
												typeOfDocument
												? typeOfDocument === 1
													? "2"
													: typeOfDocument === 6
													? "7"
													: "5"
												: ""
											}
											/>
										</DndProvider>
										<div className="error">
											{!backOfCardUrl
											? validationerror
												? warningError
												: ""
											: ""}
											{!backOfCardUrl
											? validationerror
												? "Add a photo of the back of the identity document"
												: ""
											: ""}
										</div>
										</div>
									</div>
									
									<p className="certficate_small">
										<i className="mdi mdi-lock mr-1"></i>
										Your ID is used to verify your identity and is not shared with other users of 
										Askademia
									</p>
									
									<button className="green-button" onClick={this.onSave1}>Save</button>
								
								</div>
							)
						}
						<hr className="hr"/>
						{
							!show ? (
								<div>
									<div className="flex-between-center">
										<label className="label">DBS or Criminal record certiﬁcate</label>
										<span className="btn-a" onClick={this.show} style={{ color: show1 ? "#d8d7d7" : "" }}>
											Add
										</span>
									</div>
									<p className="Text-messages">Not provided</p>
								</div>
							) :
							(                
								<div>
									<div className="flex-between-center">
										<label className="label">DBS or Criminal record certiﬁcatez</label>
										<span className="btn-a" onClick={this.hide}>Cancel</span>
									</div>
									<p className="Text-messages">
											You do not need a background check to use our platform
											tutor, however you may miss on opportunities where students
											or parents require you to have a background check
											certificate. All tutors who upload a copy of their enhanced
											background check certificate such as the DBS or PVG will be
											awarded a verification badge on their tutor profile and have
											access all tutoring jobs within their speciality.
									</p>
									<p className="label">Your certificate</p>
									<p className="Text-messages">
										Upload a colour copy of your enhanced DBS or PVG certificate
										which has been issued within the last 2 years
									</p>
									<DndProvider backend={Backend}>
									<DraggableComponent
										TargetChildComponent={CertificatePic}
										certificateError={certificateError}
										ImageUploadAction={this.props.ImageUploadAction}
										uploadedImage={this.props.uploadImage}
										errorMessagehandling={(error) => {
										this.setState({ certificateError: error });
										setTimeout(() => {
											this.setState({ certificateError: false })
											this.showAlert()
										}, 1000)
										}}
										updateImageUrl={ (e) => this.setState({ dBSCertUrl: e }) }
										imageUrl={dBSCertUrl}
										typeNo={"3"}
									/>
									</DndProvider>
									{!dBSCertUrl ? (
									this.props?.validationError?.data?.dBSCertUrl ? (
										<div className="red-alert-message" style={{ textAlign: "center" }}>
											{this.props?.validationError?.data?.dBSCertUrl}
										</div>
									) : (
										""
									)
									) : (
									""
									)}
				
									<p className="certficate_small">
										<i className="mdi mdi-lock mr-1"></i>Your certificate is
										used to verify and award you with a badge on your tutor
										profile and is not shared with other users of Askademia
									</p>
									<p className="Text-messages">
										We request updates from the{" "}
										<span style={{ color: "#2cb46d" }}>DBS update service</span>{" "}
										periodically to keep your DBS status updated. Other users of
										Askademia will not see this information.
									</p>
				
									<div className="checkBoxContainer">
										<label className="container pt-2" htmlFor="customCheck61">
											<span className="currently">
												By checking this box you authorise Askademia running
												your DBS Check through the DBS Update Service
											</span>
											<input
												type="checkbox"
												id="customCheck61"
												defaultChecked={this.state.authorizeToRunBgCheck}
												onClick={ () => this.setState({ authorizeToRunBgCheck: !this.state.authorizeToRunBgCheck })}
											/>
											<span className="checkmark"></span>
										</label>
									</div>
									
									<button className="green-button" onClick={this.onSave}>Save</button>
								
								</div>
							)
						}
						<hr className="hr"/>
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		TutorSettingReducer: { tutorSettingData },
	} = state;

	return {
		tutorSettingData,
	};
};
const mapDispatchToprops = (dispatch) => {
	return {
		TutorSettingStoreData: (payload) =>
		dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToprops
)(TutorSettingIdentification);
